import { Kiosk } from '@gozoki/api-types';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { fetchKiosk, fetchKiosks } from '../queries/kiosks.queries';

export const useKiosks = (): UseQueryResult<Kiosk[], unknown> => {
    return useQuery({
        queryKey: ['kiosks'],
        queryFn: () => {
            return fetchKiosks();
        },
    });
};

export const useKiosk = (id: number): UseQueryResult<Kiosk | null, unknown> => {
    return useQuery({
        queryKey: ['kiosk', id],
        queryFn: () => {
            if (Number.isNaN(id)) return null;
            return fetchKiosk(id);
        },
    });
};
